export async function verifyDomainCustomization(axios: any, { domain, branchId }: { domain?: string; branchId?: string }) {
  const searchParams = new URLSearchParams()
  domain && searchParams.append('domain', domain)
  branchId && searchParams.append('bid', branchId)
  const url = `/pub/domain-setting?${searchParams.toString()}`
  const res = await axios.$get(url)

  if (res.code !== 0) {
    throw new Error('verifyDomainCustomization response code is not 0')
  }
  return res
}
